export default __webpack_public_path__ + "static/zevi-logo-b7fd4f45b70b80536f83d71c50418dc2.png";